import {
    BORDER_GRAY,
    BORDER_RADIUS_SM_PX,
    NEUTRAL_BLUE,
    SURFACE_GRAY,
    SYSTEM_BLUE,
} from '@/constants/colors';
import { Close } from '@mui/icons-material';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Edit from '@mui/icons-material/Edit';
import { DialogContent, Tabs, styled } from '@mui/material';

export const StyledDecisionSupport = styled('div')`
    display: flex;

    & > button {
        padding: 0.3rem;
    }
`;

export const StyledEdit = styled(Edit)`
    width: 16px;
    height: 16px;
`;

export const StyledClose = styled(Close)`
    width: 16px;
    height: 16px;
`;

export const StyledDialogContent = styled(DialogContent)`
    padding-left: 0;
    padding-right: 0;
`;

export const StyledAutoAwesome = styled(AutoAwesome)`
    height: 20px;
    width: 20px;
`;

export const StyledField = styled('div')`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const StyledDecisionSupportTabs = styled(Tabs)`
    & .MuiTabs-indicator {
        display: none;
    }
    & .MuiTab-root {
        background-color: ${SURFACE_GRAY};
        border: 1px solid transparent;
        border-bottom: none;
        border-top-left-radius: ${BORDER_RADIUS_SM_PX}px;
        border-top-right-radius: ${BORDER_RADIUS_SM_PX}px;
        text-transform: none;
    }
    & .MuiTab-root.Mui-selected {
        background-color: #ffffff;
        border: 1px solid ${BORDER_GRAY};
    }
    & .MuiTab-root:nth-of-type(1),
    & .MuiTab-root:nth-of-type(1).Mui-selected {
        color: ${NEUTRAL_BLUE};
    }
    & .MuiTab-root:nth-of-type(2),
    & .MuiTab-root:nth-of-type(2).Mui-selected {
        color: ${SYSTEM_BLUE};
    }
`;
